export const CASE_OUTCOME = Object.freeze({
  STOPPED: "stopped",
  NOT_STOPPED: "not_stopped",
  AWAITING: "awaiting"
})

export const OUTCOME_META = {
  [CASE_OUTCOME.STOPPED]: { label: "Stopped", color: "green" },
  [CASE_OUTCOME.NOT_STOPPED]: { label: "Not stopped", color: "default" },
  [CASE_OUTCOME.AWAITING]: { label: "Awaiting outcome", color: "purple" }
}
